module.exports = __webpack_public_path__ + "img/backg2.65f056bc.png";